import { PluginCreditSenseRequest } from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runCreditSenseRequest = (
  constructPost: ConstructPost,
  data: PluginCreditSenseRequest,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructPost<NonPaginatedResponse<null>>(
    `${PLUGIN_BASE_PATH}/credit-sense-request`,
    { data },
    { preventDefaultErrorToast: true },
  );
